module.exports = __webpack_public_path__ + "static/media/icon_coin.68aaafd4.png";